import React from "react";
import "./styles.scss";
import { CustomButton } from "../../components";

export default function StartedCard(props) {
  const {
    color = "#1793D7",
    headerTitle,
    headerDesc,
    risk = "",
    percent = "",
    investFrom,
    firstIcon,
    secondIcon,
    thirdIcon,
    setAction,
    text1 = "",
    text2 = "",
    text3="",
    //inceptionDate,
    additionalTitles,
    percentColor = color,
  } = props;

  const returnLabel =
    headerTitle === "Save" ||
    headerTitle === "Invest" ||
    headerTitle === "Retire"
      ? "1Y Return"
      : "Returns*";

  return (
    <div className="started-card-box">
      <div
        className="started-card-box__header"
        style={{ "--card-header-base": color }}
      >
        {/* <img src={images.startedLogo} alt="principal-icon" /> */}
        <div className="started-card-box__header__top">
          <div className="started-card-header">
            <p className="started-card-box__header__title">{headerTitle}</p>
             {additionalTitles && (
              <p className="additionalTitles">{additionalTitles}</p>
            )}
          </div>

          <div className="started-card-box__header__metric">
            <div className="started-card-box__header__metric-main">
              <span className="started-card-box__header__upto">Up to</span>
              <p className="started-card-box__header__return">
                <span style={{ color: percentColor }}>{percent}</span>
              </p>
            </div>
          </div>
        </div>

        <div className="started-card-box__header__desc">
          <p>{headerDesc}</p>
          {risk && <span>{risk}</span>}
          <p className="started-card-box__header__label">{returnLabel}</p>
        </div>
      </div>

      <div className="started-card-box__content">
        {/*
        <p className="started-card-box__content__second">
          (As of {moment(inceptionDate).format("D MMM YYYY")})
        </p>
        */}
        <div className="started-card-box__content__info">
          {text1 && (
            <div>
              <img src={firstIcon} alt="first-icon" />
              <p>{text1}</p>
            </div>
          )}
          {text2 && (
            <div>
              <img src={secondIcon} alt="second-icon" />
              <p>{text2}</p>
            </div>
          )}
          {text3 && (
            <div>
              <img src={thirdIcon} alt="third-icon" />
              <p>{text3}</p>
            </div>
          )}
        </div>
        <div className="started-card-box__content__action">
          <p>
            Invest from <span>{investFrom}</span>
          </p>
          <CustomButton
            style={{ width: "6.75rem", height: "2.5rem", padding: "0.5rem 0.75rem" }}
            text="Next →"
            variant="outlined"
            color="#fff"
            backgroundColor="#1278CC"
            onClick={setAction}
          />
        </div>
      </div>
    </div>
  );
}
